// UI translations
export const ui = {
  it: {
    seleziona: "Seleziona",
    prenotaOra: "Prenota ora",
    scopri: "Scopri Il Ponticello",
    back: "Indietro",
    allergens: "Allergeni",
    vediAnche: "Vedi anche",
    categoriaNon: "Categoria non trovata",
    sezioneNon: "Sezione non trovata",
    tornaMenu: "Torna al menù",
    menu: "Menù",
    admin: "Admin",
    logout: "Esci",
    login: "Accedi",
    password: "Password",
    save: "Salva",
    saved: "Salvato!",
    add: "Aggiungi",
    delete: "Elimina",
    edit: "Modifica",
    qrTitle: "Menù QR Code",
    qrDesc: "Stampa questo codice e mettilo sui tavoli. I clienti inquadrano con lo smartphone e aprono il menù al volo.",
    print: "Stampa",
    downloadQr: "Scarica PNG",
    price: "Prezzo",
    name: "Nome",
    description: "Descrizione",
    image: "Immagine (URL)",
    newItem: "Nuovo piatto",
    selectSub: "Seleziona una sezione per modificare",
    manageMenu: "Gestione menù",
    allergensLegendTitle: "Legenda allergeni",
    allergensLegend: [
      { n: 1, label: "Glutine" },
      { n: 3, label: "Uova" },
      { n: 4, label: "Pesce" },
      { n: 7, label: "Latte e derivati" },
      { n: 8, label: "Frutta a guscio" },
      { n: 9, label: "Sedano" },
      { n: 11, label: "Semi di sesamo" },
    ],
  },
  en: {
    seleziona: "Select",
    prenotaOra: "Book now",
    scopri: "About Il Ponticello",
    back: "Back",
    allergens: "Allergens",
    vediAnche: "See also",
    categoriaNon: "Category not found",
    sezioneNon: "Section not found",
    tornaMenu: "Back to menu",
    menu: "Menu",
    admin: "Admin",
    logout: "Logout",
    login: "Login",
    password: "Password",
    save: "Save",
    saved: "Saved!",
    add: "Add",
    delete: "Delete",
    edit: "Edit",
    qrTitle: "Menu QR Code",
    qrDesc: "Print this code and place it on the tables. Guests scan it and open the menu instantly.",
    print: "Print",
    downloadQr: "Download PNG",
    price: "Price",
    name: "Name",
    description: "Description",
    image: "Image (URL)",
    newItem: "New item",
    selectSub: "Select a section to edit",
    manageMenu: "Menu management",
    allergensLegendTitle: "Allergens legend",
    allergensLegend: [
      { n: 1, label: "Gluten" },
      { n: 3, label: "Eggs" },
      { n: 4, label: "Fish" },
      { n: 7, label: "Milk and dairy" },
      { n: 8, label: "Nuts" },
      { n: 9, label: "Celery" },
      { n: 11, label: "Sesame seeds" },
    ],
  },
};

export const tr = (val, lang) => {
  if (val === null || val === undefined) return "";
  if (typeof val === "string") return val;
  if (typeof val === "object") return val[lang] || val.it || val.en || "";
  return String(val);
};
